import React from 'react';
import {observer, inject} from 'mobx-react';
import styled from 'styled-components';


class LightBox extends React.Component {
  constructor(props) {
    super(props);
    this.closeLightBox = this.closeLightBox.bind(this);
  }

  closeLightBox() {
    this.props.state.setLightBox(undefined);
  }

  render() {
    const imgSrc = this.props.state.lightBoxImage;
    const LB = styled.div`
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
    `;

    const LBBackground = styled.div`
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: black;
      opacity: 0.6;
      z-index: -1;
    `;

    const LBWrapper = styled.div`
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    `;

    const LBImage = styled.img`
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    `;

    const LBSpinner = styled.span`
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      font-size: 2rem;
      color: #4f803d;
      z-index: -1;
    `;

    const LBClose = styled.span`
      position: absolute;
      top: -6px;
      right: 2px;
      font-size: 1.5rem;
      cursor: pointer;
      color: #4f803d;
      opacity: 0.6;
    `;

    return (
      (imgSrc !== undefined ?
        (
        <LB>
          <LBBackground onClick={this.closeLightBox}/>
          <LBWrapper>
            <LBClose onClick={this.closeLightBox}>
              <i className="fas fa-times"/>
            </LBClose>
            <LBSpinner>
              <i className="fa fa-spinner fa-spin"/>
            </LBSpinner>
            <LBImage src={imgSrc} /></LBWrapper>
        </LB>
        ): <span/>
      )
    )
  }
}

export default inject("state")(observer(LightBox));


// WEBPACK FOOTER //
// ./src/components/LightBox.jsx